module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    staticClass: "button is-primary is-pulled-right",
    attrs: {
      "to": {
        name: 'page-create'
      }
    }
  }, [_vm._v("Create Page")]), _vm._v(" "), _c('data-table', {
    attrs: {
      "data-set": _vm.filteredPages,
      "page-length": 50,
      "columns": [{
          name: 'Page',
          prop: 'name',
          type: 'text'
        },
        {
          name: 'Updated',
          prop: 'updated_at',
          type: 'date',
          sortable: false,
          filter: ['moment', ['from', 'now']]
        },
        {
          name: 'Created',
          prop: 'created_at',
          type: 'date',
          sortable: false,
          filter: ['moment', ['from', 'now']]
        } ]
    },
    scopedSlots: _vm._u([{
      key: "column_Page",
      fn: function(props) {
        return [_c('div', {
          staticClass: "level"
        }, [_c('div', {
          staticClass: "level-left"
        }, [_c('div', {
          staticClass: "level-item",
          staticStyle: {
            "min-width": "220px"
          }
        }, [(_vm.getImage(props.row)) ? _c('router-link', {
          attrs: {
            "to": {
              name: 'page',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.getImage(props.row).thumbnail_path
          }
        })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "level-item"
        }, [_c('div', {
          staticStyle: {
            "max-width": "400px"
          }
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'page',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_vm._v("\n                " + _vm._s(props.row.name) + _vm._s(props.row.company !== null ? ' (' + props.row.company + ' ONLY)' : '') + "\n              ")]), _vm._v(" "), _c('br'), _vm._v("\n              /" + _vm._s(props.row.slug) + "\n              "), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "has-text-grey"
        }, [_vm._v(_vm._s(props.row.keywords))])], 1)])])])]
      }
    }, {
      key: "controls",
      fn: function(props) {
        return [_c('td', {
          staticClass: "has-text-right table-controls",
          attrs: {
            "slot": "controls"
          },
          slot: "controls"
        }, [(props.row.enabled) ? _c('a', {
          attrs: {
            "title": "Disable Page"
          },
          on: {
            "click": function($event) {
              return _vm.disablePage(props.row)
            }
          }
        }, [_c('span', {
          staticClass: "icon"
        }, [_c('i', {
          staticClass: "fa fa-toggle-on"
        })])]) : _c('a', {
          attrs: {
            "title": "Enable Page"
          },
          on: {
            "click": function($event) {
              return _vm.enablePage(props.row)
            }
          }
        }, [_c('span', {
          staticClass: "icon"
        }, [_c('i', {
          staticClass: "fa fa-toggle-off"
        })])]), _vm._v(" "), _c('button', {
          staticClass: "button is-small",
          attrs: {
            "disabled": props.row.display_order <= 1,
            "type": "button",
            "title": "move up"
          },
          on: {
            "click": function($event) {
              return _vm.moveUp(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-up"
        })]), _vm._v(" "), _c('button', {
          staticClass: "button is-small",
          attrs: {
            "disabled": props.row.display_order >= _vm.pages.length,
            "type": "button",
            "title": "move down"
          },
          on: {
            "click": function($event) {
              return _vm.moveDown(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-down"
        })]), _vm._v(" "), _c('a', {
          staticClass: "delete",
          on: {
            "click": function($event) {
              return _vm.deletePage(props.row)
            }
          }
        }), _vm._v("\n         \n         \n      ")])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e56ad9b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/pages/PageList.vue
// module id = 526
// module chunks = 0